import BaseComponent from 'scripts/components/base-component'

class CookiesPolicy extends BaseComponent {
  static componentName = 'cookies-policy'

  static DOMEvents = {
    'click [data-trigger-accept]': 'onElementClick'
  }

  init () {
    this.hasCookie()
  }

  hasCookie () {
    if (!localStorage.getItem('cookies-accepted')) {
      this.$element.addClass('cookies--visible')
    }
  }

  setCookie () {
    localStorage.setItem('cookies-accepted', true)
    this.$element.removeClass('cookies--visible')
  }

  onElementClick (event) {
    this.setCookie()
  }
}

export default $el => new CookiesPolicy($el).init()

export { CookiesPolicy as Component }
